'use strict';

// Services
import ListModel from 'common/components/list/listModel.service';
import { validAccess } from 'accessControl';
const __endpoints = require('endpoints.service');

export default class NationalitiesList extends ListModel {
	constructor(reduxKey) {
		super(reduxKey);
		this.headers = [
			{
				name: 'name',
				type: 'string',
				canAdd: true,
				canEdit: true,
				required: true,
			},
		];
		this.settings = {
			name: 'NationalitiesList',
			canAdd: true,
			hasDetails: true,
			canDelete: true,
			pageTitle: true,
			translationPath: 'ADMINISTRATION.NATIONALITIES',
			canManipulate: () => validAccess(undefined, ['Global HR Configuration']),
			endpoint: __endpoints.collection.administration.nationalities,
		};
		this.init();
		return this;
	}
}
